module.exports = __webpack_public_path__ + "media/images/logo-992259e158ea3d747678f2b3fb993eb0.png";